import { defineComponent as _defineComponent } from 'vue'
import { toDisplayString as _toDisplayString, normalizeClass as _normalizeClass, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

import { CalendarDayModel } from '@/services/entities/Reporting/CalendarDayModel';


export default /*@__PURE__*/_defineComponent({
  __name: 'CalendarDay',
  props: {
    dayData: {}
  },
  setup(__props: any) {

const props = __props;

function getBackgroudnClass() {
  const common = 'calendar-day-visual';  
  if ((props.dayData.hours === 0) && (!props.dayData.outOfOffice))
    return  common;
  if (props.dayData.isAbsent && props.dayData.outOfOffice) {
    return `${common} combo-absent-ooo`;
  } else if (props.dayData.isAbsent && props.dayData.isPresent) {
    return `${common} combo-absent-present`;
    // other combinations are in simplicity not possible - cannot be determined from the data model
  } else if (props.dayData.isAbsent) {
    return `${common} absent`;
  } else if (props.dayData.outOfOffice) {
    return `${common} out-of-office`;
  } else if (props.dayData.isPresent) {
    return `${common} present`;
  }
}

const getDayData = (): string => {
  if (props.dayData.hours == null) {
    return "";
  }
  return props.dayData.hours > 0
    ? `${props.dayData.hours}`
    : "-";
}


return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", {
    class: _normalizeClass( getBackgroudnClass())
  }, _toDisplayString(getDayData()), 3))
}
}

})